"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var reconnect_js_1 = require("reconnect.js");
var Form_1 = __importDefault(require("../../Generic/Form"));
var antd_1 = require("antd");
var JStorageUtil_1 = require("../../Utils/JStorageUtil");
var JStorageActions = __importStar(require("../../Actions/JStorage"));
var StorageActions = __importStar(require("../../Actions/Storage"));
var FileUpload_1 = __importDefault(require("./FileUpload"));
function getUrl(renameImageField, instance) {
  return renameImageField.referenceImageFieldKey.split('.').reduce(function (acc, curr) {
    var _a = curr.match(/^(\w+)\[([0-9]+)\]$/) || [],
      field = _a[1],
      index = _a[2];
    if (field) {
      return acc[field][Number(index)];
    }
    return acc[curr];
  }, instance);
}
function AdminForm(props) {
  var _this = this;
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var _renderCustomSection = props.renderCustomSection,
    initialInstance = props.instance,
    collection = props.collection,
    actionBar = props.actionBar,
    formSpec = props.formSpec,
    config = props.config,
    path = props.path,
    primaryKey = props.primaryKey,
    modifyJStorageArgs = props.modifyJStorageArgs;
  var user = reconnect_js_1.useOutlet('user')[0];
  var _a = react_1.default.useState(initialInstance),
    instance = _a[0],
    setInstance = _a[1];
  var _b = modifyJStorageArgs || {},
    modifyCreateDocumentArgs = _b.modifyCreateDocumentArgs,
    modifyUpdateDocumentArgs = _b.modifyUpdateDocumentArgs;
  function goToArticle(id) {
    if (!id) {
      window.open(config.articleEditorHost + "?token=" + user.token, '_blank');
    } else {
      window.open(config.articleEditorHost + "?token=" + user.token + "&id=" + id, '_blank');
    }
  }
  function autoHandlerAfterFormSubmit(instance, oldInstance) {
    return __awaiter(this, void 0, void 0, function () {
      var foundRenameImageFields, renameFields, _i, foundRenameImageFields_1, renameImageField, url, oldUrl, imageResponse, blob, file, resp, formData, payload, key, err_1, updatedInstance;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!formSpec.uiSchema) return [3 /*break*/, 12];
            foundRenameImageFields = Object.keys(formSpec.uiSchema).map(function (key) {
              return __assign({
                key: key
              }, formSpec.uiSchema[key]);
            }).filter(function (f) {
              return f['ui:field'] === 'rev-rename-image';
            });
            renameFields = {};
            _i = 0, foundRenameImageFields_1 = foundRenameImageFields;
            _b.label = 1;
          case 1:
            if (!(_i < foundRenameImageFields_1.length)) return [3 /*break*/, 10];
            renameImageField = foundRenameImageFields_1[_i];
            if (!!renameImageField.referenceImageFieldKey) return [3 /*break*/, 2];
            console.warn("rev-rename-image must have \"referenceImageFieldKey\": " + renameImageField.key);
            return [3 /*break*/, 9];
          case 2:
            _b.trys.push([2, 8,, 9]);
            url = getUrl(renameImageField, instance);
            oldUrl = getUrl(renameImageField, oldInstance);
            if (!(oldUrl !== url)) return [3 /*break*/, 7];
            return [4 /*yield*/, fetch(url)];
          case 3:
            imageResponse = _b.sent();
            return [4 /*yield*/, imageResponse.blob()];
          case 4:
            blob = _b.sent();
            file = new File([blob], "image." + blob.type.split('/').pop(), {
              type: blob.type
            });
            return [4 /*yield*/, StorageActions.getUploadUrlFromFile(file, {
              token: user.token
            })];
          case 5:
            resp = _b.sent();
            formData = new FormData();
            payload = __assign(__assign({}, resp.fields), {
              file: file
            });
            for (key in payload) {
              formData.append(key, payload[key]);
            }
            return [4 /*yield*/, StorageActions.uploadFile(resp.url, formData)];
          case 6:
            _b.sent();
            renameFields[renameImageField.key] = resp.expected;
            _b.label = 7;
          case 7:
            return [3 /*break*/, 9];
          case 8:
            err_1 = _b.sent();
            console.warn('an error occur while renaming file...', err_1);
            return [3 /*break*/, 9];
          case 9:
            _i++;
            return [3 /*break*/, 1];
          case 10:
            if (!(Object.keys(renameFields).length !== 0)) return [3 /*break*/, 12];
            return [4 /*yield*/, JStorageActions.updateDocument(collection, (_a = {}, _a[primaryKey] = instance[primaryKey], _a), JStorageUtil_1.removeAutoFields(__assign(__assign({}, instance), renameFields)))];
          case 11:
            updatedInstance = _b.sent();
            setInstance(updatedInstance);
            _b.label = 12;
          case 12:
            return [2 /*return*/, null];
        }
      });
    });
  }
  return react_1.default.createElement("div", null, react_1.default.createElement(Form_1.default, {
    schema: formSpec.schema,
    uiSchema: formSpec.uiSchema,
    errorSchema: formSpec.errorSchema,
    rjsfProps: props.rjsfProps,
    instance: instance,
    formId: formSpec.formId,
    onSubmit: function onSubmit(formData, extValues, setValues) {
      if (extValues === void 0) {
        extValues = {};
      }
      if (setValues === void 0) {
        setValues = function setValues(v) {
          return 0;
        };
      }
      return __awaiter(_this, void 0, void 0, function () {
        var field, handled, nextInstance, dataToUpdate, args, args, ex_1;
        var _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (formSpec.onSubmit === null) {
                AppActions.setLoading(false);
                return [2 /*return*/];
              }
              // workaround for rjsf's strange hehavior to mark empty string as undefined
              for (field in formData) {
                if (formData[field] === undefined && instance && typeof instance[field] === 'string') {
                  formData[field] = '';
                }
              }
              return [4 /*yield*/, AppActions.onAdminFormSubmit({
                path: path,
                collection: collection,
                instance: instance,
                extValues: extValues,
                formData: formData,
                formSchema: formSpec.schema,
                formUiSchema: formSpec.uiSchema,
                primaryKey: primaryKey
              })];
            case 1:
              handled = _b.sent();
              if (handled) {
                return [2 /*return*/];
              }

              _b.label = 2;
            case 2:
              _b.trys.push([2, 10, 11, 12]);
              AppActions.setLoading(true);
              nextInstance = null;
              dataToUpdate = __assign(__assign({}, formData), extValues);
              if (!!instance) return [3 /*break*/, 4];
              args = [collection, dataToUpdate];
              if (modifyCreateDocumentArgs) {
                args = modifyCreateDocumentArgs.apply(void 0, args);
              }
              return [4 /*yield*/, JStorageActions.createDocument.apply(JStorageActions, args)];
            case 3:
              nextInstance = _b.sent();
              return [3 /*break*/, 6];
            case 4:
              args = [collection, (_a = {}, _a[primaryKey] = instance[primaryKey], _a), JStorageUtil_1.removeAutoFields(dataToUpdate)];
              if (modifyUpdateDocumentArgs) {
                args = modifyUpdateDocumentArgs.apply(void 0, args);
              }
              return [4 /*yield*/, JStorageActions.updateDocument.apply(JStorageActions, args)];
            case 5:
              nextInstance = _b.sent();
              _b.label = 6;
            case 6:
              setInstance(nextInstance);
              return [4 /*yield*/, autoHandlerAfterFormSubmit(nextInstance, instance)];
            case 7:
              _b.sent();
              if (!AppActions.onAfterAdminFormSubmit) return [3 /*break*/, 9];
              return [4 /*yield*/, AppActions.onAfterAdminFormSubmit({
                path: path,
                collection: collection,
                instance: instance,
                extValues: extValues,
                formData: formData,
                formSchema: formSpec.schema,
                formUiSchema: formSpec.uiSchema,
                primaryKey: primaryKey
              }, nextInstance)];
            case 8:
              _b.sent();
              _b.label = 9;
            case 9:
              if (!instance) {
                AppActions.navigate(path);
              }
              antd_1.message.success('成功!');
              return [3 /*break*/, 12];
            case 10:
              ex_1 = _b.sent();
              antd_1.message.error('API failure');
              return [3 /*break*/, 12];
            case 11:
              AppActions.setLoading(false);
              return [7 /*endfinally*/];
            case 12:
              return [2 /*return*/];
          }
        });
      });
    },

    renderCustomSection: function renderCustomSection(props) {
      if (_renderCustomSection) {
        return _renderCustomSection({
          type: 'form',
          name: formSpec.customName || 'AdminForm',
          context: props
        });
      }
      // customRenderFunc backward compatibility
      if (AppActions.renderCustomAdminSection) {
        return AppActions.renderCustomAdminSection({
          type: 'form',
          name: formSpec.customName || 'AdminForm',
          context: props
        });
      }
      return null;
    },
    renderCustomSubmitButton: formSpec.submitButton === null ? null : undefined
  }), actionBar && actionBar.length > 0 && react_1.default.createElement("div", {
    style: {
      marginTop: 10,
      borderTop: '1px solid #ccc',
      padding: '15px 0'
    }
  }, react_1.default.createElement("h3", null, "\u5DE5\u5177\u5217"), react_1.default.createElement("div", {
    style: {
      marginTop: 10
    }
  }, actionBar.find(function (action) {
    return action === 'file';
  }) && react_1.default.createElement(FileUpload_1.default, {
    onFinished: function onFinished(url) {
      console.log('result url', url);
    }
  }), actionBar.find(function (action) {
    return action === 'article';
  }) && react_1.default.createElement(antd_1.Button, {
    style: {
      marginLeft: 8
    },
    onClick: function onClick() {
      return goToArticle();
    }
  }, "\u5275\u5EFA\u6587\u7AE0"), actionBar.find(function (action) {
    return action === 'article';
  }) && react_1.default.createElement(antd_1.Button, {
    style: {
      marginLeft: 8
    },
    disabled: !(instance && instance.article),
    onClick: function onClick() {
      return goToArticle(instance && instance.article);
    }
  }, "\u7DE8\u8F2F\u6587\u7AE0"))));
}
exports.default = AdminForm;